import {match, P} from 'ts-pattern'
import {zx} from 'shared/type'
import {z} from 'zod'
import type {Permission} from './permission'
import {zTourSettings} from './tourTypes'
import {type Role, zRoles} from 'shared/forecast/roleTypes'
import {WorkspaceTypes as W} from 'shared/forecast/workspaceTypes'
import {zLicense} from 'shared/forecast/license'
import {Duration} from 'luxon'
export const zProfileCfg = z.object({
  name: z.string().default(''),
  avatar_url: zx.nullish.string,
  roles: zx.nullishToUndefined(z.array(zRoles).default([])),
  notify: z
    .object({
      email: z.boolean().default(true)
    })
    .default({}),
  tz: z.string().optional(),
  favorite: z.boolean().optional(),
  isRandomPlaceholder: z.boolean().optional()
})

export const zProfileCfgGlobal = zProfileCfg.extend({
  tour: zTourSettings.default({})
})

/** coerces to lower case email string and validates it */
export const zEmail = z.preprocess(
  v =>
    match(v)
      .with(P.nullish, () => undefined)
      .with(P.string, s => s.toLowerCase())
      .otherwise(v => String(v)),
  z.string().optional()
)

export const zProfileRow = z.object({
  id: z.string(),
  user_id: zx.nullish.string,
  workspace_id: z.string(),
  // email: zEmail, // now always get this from user
  cfg: zProfileCfg.passthrough(),
  deleted: z.boolean().optional(),
  updated_at: z.string()
})

export type ProfileCfg = z.infer<typeof zProfileCfg>
export type ProfileRow = z.infer<typeof zProfileRow>
export type ProfileCfgGlobal = z.infer<typeof zProfileCfgGlobal>

export type Profile = Omit<ProfileRow, 'cfg'> &
  ProfileCfg & {hasRole: (role: Role) => boolean; hasPermission: (permission: Permission) => boolean}

export type FetchProfileProps = {
  invite?: {
    workspace: string
    id: string
  }
}

export const zProfileAdminRow = zProfileRow
  .omit({updated_at: true})
  .extend({email: zx.nullish.string, is_anonymous: zx.nullish.bool, created_at: z.string()})

export type ProfileUI = Pick<Profile, 'id' | 'name' | 'avatar_url' | 'roles'>

export const zProfileWorkspaceCfg = W.zCfg.omit({domains: true, inviteLinks: true, requests: true})
type ProfileWorkspaceCfg = z.infer<typeof zProfileWorkspaceCfg>

export const zProfileLicense = zLicense.omit({enabled: true, notes: true})
export type ProfileLicense = z.infer<typeof zProfileLicense>

export type MyProfile = {
  workspace: ProfileWorkspaceCfg
  is_new?: boolean
  license?: ProfileLicense
  readonly: boolean
} & Profile

export const profileParticipantExpiry = Duration.fromObject({days: 14})

export const systemProfileId = 'system'
